/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Secondary_Goal_EventInputs */

const en_us2_onboarding_secondary_goal_event = /** @type {(inputs: Onboarding_Secondary_Goal_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare for an event`)
};

const pt_br2_onboarding_secondary_goal_event = /** @type {(inputs: Onboarding_Secondary_Goal_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me preparar para um evento`)
};

const es_419_onboarding_secondary_goal_event = /** @type {(inputs: Onboarding_Secondary_Goal_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepararme para un evento`)
};

const pt_pt2_onboarding_secondary_goal_event = /** @type {(inputs: Onboarding_Secondary_Goal_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparar-me para um evento`)
};

const fr_fr2_onboarding_secondary_goal_event = /** @type {(inputs: Onboarding_Secondary_Goal_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparer un événement`)
};

const de_de2_onboarding_secondary_goal_event = /** @type {(inputs: Onboarding_Secondary_Goal_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mich auf ein Event vorbereiten`)
};

const it_it2_onboarding_secondary_goal_event = /** @type {(inputs: Onboarding_Secondary_Goal_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepararmi per un evento`)
};

/**
* | output |
* | --- |
* | "Prepare for an event" |
*
* @param {Onboarding_Secondary_Goal_EventInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_secondary_goal_event = /** @type {((inputs?: Onboarding_Secondary_Goal_EventInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Secondary_Goal_EventInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_secondary_goal_event(inputs)
	if (locale === "es-419") return es_419_onboarding_secondary_goal_event(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_secondary_goal_event(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_secondary_goal_event(inputs)
	if (locale === "de-DE") return de_de2_onboarding_secondary_goal_event(inputs)
	if (locale === "it-IT") return it_it2_onboarding_secondary_goal_event(inputs)
	return en_us2_onboarding_secondary_goal_event(inputs)
});
export { onboarding_secondary_goal_event as "onboarding.secondary_goal.event" }